import React, { useState, useEffect } from "react";
import config2 from "../Util/config";
import "./Applicant.css";
import "./Style.css";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import { useLocation } from "react-router-dom";
import { UpdateTabData } from "../Requests/mutators";
import { getToken } from "../Util/Authenticate";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import URLconfig from "../Util/URLConfig";
const TabDetails = () => {
  const [isLoading, setisLoading] = React.useState(true);
  const location = useLocation();
  if (location.state) {
    let savetabId = JSON.stringify(location.state.tabId);
    localStorage.setItem("tabId", savetabId);
  }
  let tabId = JSON.parse(localStorage.getItem("tabId"));
  const [updateTabdetails, setupdateTabdetails] = useState({
    tabId: tabId,
    tabName: "",
    isAvaliable: -1,
  });
  const GetTabDetails = () => {
    var data = "";
    var config = {
      method: "post",
      url: `${config2.BASE_URL}/api/Admin/GetTabsbyID?tabID=${tabId}`,
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        //console.log("Admin Course Details API", JSON.stringify(response.data));
        setupdateTabdetails(response.data);
        //console.log("Start Date: ", response.data.courseStartDate.toString().split('T')[0]);
      })
      .catch(function (error) {
        //console.log(error);
      });
  };
  const UpdateCourseDataAsyc = async () => {
    try {
      setisLoading(true);
      await UpdateTabData(updateTabdetails);
      setisLoading(false);
      alert("Update Occured Successfully");
      // window.location.href = "/#/dashboard";
      // window.location.href = `${URLconfig.BASE_URL}Policies/#/dashboard`;
      //window.location.href = `http://localhost:3000/#/dashboard`;
    } catch (err) {
      setisLoading(false);
      alert("Error while Updating user details, Please Try Again");
    }
  };
  useEffect(() => {
    setisLoading(false);
    GetTabDetails();
  }, []);
  return (
    <div>
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-lg-8 col-xl-6">
          <div class="card rounded-3">
            <div class="card-body p-4 p-md-5">
              <h3 class="mb-4 pb-2 pb-md-0 mb-md-5 px-md-2 ButtonFrame">
                Tab Information Panel
              </h3>
              <hr></hr>
              <ValidatorForm onSubmit={UpdateCourseDataAsyc} class="px-md-2">
                <div class="form-outline w-100 mb-4">
                  <TextField
                    type="text"
                    id="form3Example1q"
                    className="w-100"
                    value={updateTabdetails.tabName}
                    onChange={(e) => {
                      setupdateTabdetails({
                        ...updateTabdetails,
                        tabName: e.target.value,
                      });
                    }}
                    name="tabName"
                    label="Tab Name"
                  />
                </div>
                <h3 class="mb-4 pb-2 pb-md-0 mb-md-5 px-md-2">
                  Tab Avaliability
                </h3>
                <hr></hr>
                <div class="form-outline mb-4">
                  <select
                    class="form-select"
                    value={updateTabdetails.isAvaliable}
                    onChange={(e) => {
                      setupdateTabdetails({
                        ...updateTabdetails,
                        isAvaliable: Number(e.target.value),
                      });
                    }}
                    name="roleId"
                  >
                    <option value="1">Active</option>
                    <option value="0">Not Active</option>
                  </select>
                </div>
                <button
                  type="submit"
                  class="btn btn-success col-3"
                  // onClick={() => UpdateCourseDataAsyc()}
                  disabled={isLoading}
                >
                  {isLoading == true ? "Changing Tab..." : "Edit Tab"}
                </button>
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabDetails;
